import DomainList from "./DomainList.js";
import useAxios from "axios-hooks";
import Spinner from 'react-bootstrap/Spinner';
import React from "react";

function DomainBox(props) {
  const [{ data, loading, error }] = useAxios({
    url: props.url,
  });
  if (loading || !data) {
    return (
      <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  if (error != null) {
    return <div>Error:{JSON.stringify(error, null, 2)}</div>;
  }
  return (
    <div>
      <DomainList data={data} />
    </div>
  );
}

export default DomainBox;
